import styled from 'styled-components'

import {
  BaseColor,
  Breakpoint,
  Color,
  IconStyled,
  Typography,
  border,
  borderRadius,
  breakpointEnding,
  rem,
  spacing,
  themeColor,
  link,
  Button,
} from '@unbounded/unbounded-components'

export const ConnectToEthereum = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${spacing()};
`

export const BoundsBalanceWrapper = styled.div`
  position: relative;
  border-radius: ${borderRadius};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: ${rem(1)};
  min-width: 0;
  border: ${rem(2)} solid ${themeColor(BaseColor.min)};
  background: ${themeColor(BaseColor.min)};
`

export const BoundsBalance = styled.div`
  background: ${themeColor(Color.primary)};
  display: flex;
  padding: ${spacing()};
  align-items: center;
  justify-content: center;
  text-align: center;

  @media (${breakpointEnding(Breakpoint.md)}) {
    flex-direction: column;
    justify-content: center;
  }
`

export const L1Balance = styled(BoundsBalance)`
  padding-bottom: ${spacing(2)};
  background: #434871;
`

export const L2Balance = styled(BoundsBalance)`
  padding-top: ${spacing(2)};
  background: #111525;
`

export const BoundsBalanceAmount = styled.div`
  color: white;
  ${Typography.headlineLarge};
`

export const BoundsBalanceCaption = styled.div`
  display: block;
  ${Typography.bodyMedium};
  margin-bottom: ${spacing(0.5)};
`

export const BoundsBalanceBuyWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const BoundsBalanceBuy = styled.div`
  position: absolute;
  top: ${rem(-22)};
  border-radius: calc(${borderRadius} * 1.5);
  border: ${rem(2)} solid ${themeColor(BaseColor.min)};
  background: ${themeColor(BaseColor.min)};
  display: flex;
  align-items: center;
  justify-content: center;

  @media (${breakpointEnding(Breakpoint.md)}) {
  }
`

export const ReloadTokenBalance = styled(Button).attrs({
  color: 'base',
  variant: 'transparent',
  shape: 'square',
  size: 'large',
})`
  position: absolute;
  top: 0;
  right: 0;
  color: ${themeColor(BaseColor.min)};
  &:hover,
  &:active {
    color: ${themeColor(BaseColor.shade_10)};
  }
`

export const SendTokensModal = styled.div`
  margin-top: ${spacing()};
  max-width: min(calc(100vw - ${spacing(4)}), ${rem(580)});
`

export const ModalActionButtons = styled.div`
  margin-top: ${spacing()};
  border-top: ${border};
  padding-top: ${spacing()};
  display: flex;
  align-items: center;
  justify-content: center;
`

const TransferCell = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  height: 100%;
  width: 100%;
`

export const TransferDate = styled(TransferCell)``

export const TransferStatus = styled(TransferCell)``

export const TransferTransaction = styled(TransferCell)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const VestingClaimed = styled.span`
  color: ${themeColor(Color.info)};
`

export const VestingUnlocked = styled.span`
  color: ${themeColor(Color.success)};
`

export const VestingPending = styled.span``

export const TransferTransactionId = styled.div`
  ${Typography.bodyMedium};
  ${Typography.textSemiStrong};
`

export const TransferTransactionBlock = styled.div`
  ${Typography.bodySmall};
  color: ${themeColor(BaseColor.shade_40)};
  margin-top: ${spacing(0.25)};
`

export const TransfersTableContainer = styled.div`
  margin-top: ${spacing()};
`

export const TransfersTableTitle = styled.h2`
  ${Typography.headlineMedium};
  margin-bottom: ${spacing()};
  text-align: center;
`

export const TransferActions = styled(TransferCell)`
  display: flex;
  justify-content: flex-end;
`

export const NoUnclaimedTransfers = styled.div`
  display: flex;
  min-height: ${rem(200)};
  align-items: center;
  justify-content: center;
  min-width: 0;
  flex-direction: column;
  color: ${themeColor(BaseColor.shade_40)};

  ${IconStyled} {
    margin-bottom: ${spacing(2)};
    width: ${rem(64)};
    height: ${rem(64)};
  }
`

export const TransfersPagination = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
`

const GenericPage = styled.div`
  background: ${themeColor(BaseColor.shade_20)};
  padding: ${spacing(1)} ${spacing(1.5)};
  cursor: pointer;
  user-select: none;

  &:hover {
    background: ${themeColor(BaseColor.shade_30)};
  }
`

export const LeftPage = styled(GenericPage)`
  margin-right: auto;
`

export const RightPage = styled(GenericPage)`
  margin-left: auto;
`

export const TabsPadding = styled.div``

export const VestingHeader = styled.h3`
  text-align: center;
  margin: ${spacing(3)} 0;
  ${Typography.titleMedium};
`

export const WhatsThis = styled.div`
  a {
    ${link};
  }
  text-align: center;
  margin-top: ${spacing(2)};
`

export const BalanceLoading = styled.div`
  ${IconStyled} {
    display: inline;
    width: 1em;
    height: 1em;
    position: relative;
    top: -0.2em;
  }
`
